export interface Monitorable {
  startMonitors?(): () => void;
  stopMonitors?(): void;
}

export function startMonitors(monitorable: Record<string, Monitorable>) {
  for (const m of Object.values(monitorable)) m.startMonitors?.();
}

export function stopMonitors(monitorable: Record<string, Monitorable>) {
  for (const m of Object.values(monitorable)) m.stopMonitors?.();
}
